var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('message-modal'),_c('div',[_c('main-header'),_c('linehaul-road-list-filter'),_c('linehaul-road-list-header'),_c('linehaul-road-list-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }